export const apiLoginCred = {
  identifier: 'apiUser',
  password: '2TcB*nN@44hR',
}
